module.exports = __webpack_public_path__ + "img/product-4.cf1211af.png";